import React from 'react';
import CGV from '../components/CGV';
import VisiteWidget from '../components/Visite';
import DonationWidget from '../components/DonationWidget';

function App() {
  return (
    <div className="App">
      <CGV />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
